import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
import { CreateButton, FormFooter, IsSubmittingButton } from "../../components";
import { Button, Grid } from "@mui/material";
import { useCustomer, useLocales, useUser } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import ModalDocument from "./ModalDocument";
import { saveHandler } from "../../handlers";
import Swal from "sweetalert2";
import { useCreateMutation } from "../../features/api/Api";
import { useState } from "react";
import {
  clean,
  isExists,
  workOrderStatusEnum,
  workOrderTypeEnum,
} from "../../utils";

const Cancelation = () => {
  const [openDoc, setOpenDoc] = useState<boolean>(false);
  const [sendToDocument, setSendToDocument] = useState<boolean>(false);
  const { user } = useUser();
  const { customerName } = useCustomer(user.customerId);
  const [create] = useCreateMutation();
  const { translate } = useLocales();
  const { customerId } = useParams();

  const history = useNavigate();

  function createMethodWorkOrder(values: any, { setSubmitting }: any) {
    create({
      resource: `fixity/workorder/workorder`,
      params: values,
    })
      .unwrap()
      .then(() => {
        Swal.fire(translate("actions.saved"), "", "success");
        history(-1);
      })
      .catch((err) => {
        const error = err.data?.errors?.[0];
        Swal.fire(translate("actions.error"), error, "error");
        setSubmitting(false);
      });
  }
  function createMethod(values: any, { setSubmitting }: any) {
    create({
      resource: `fixity/customer/document`,
      params: values.document,
    })
      .unwrap()
      .then((res: any) => {
        Swal.fire(translate("actions.saved"), "", "success");

        const customerId = res.data.customerId;
        values.workOrder.customerId = customerId;
        saveHandler(
          clean(values.workOrder),
          { setSubmitting },
          createMethodWorkOrder
        );
      })
      .catch((err) => {
        const error = err.data?.errors?.[0];
        Swal.fire(translate("actions.error"), error, "error");
        setSubmitting(false);
      });
  }

  function submitHandler(values: any, { setSubmitting }: any) {
    const workOrderValues = {
      statusId: workOrderStatusEnum.open,
      typeId: workOrderTypeEnum.request,
      organizationGroupId: "95fdc3f9-2240-46bf-800d-02d13df96bd8",
      title: "Fesih Talebi",
      description: `Bu iş emri ${customerName} bayisinin fesih talebi için açılmıştır. ${user.given_name} ${user.family_name} tarafından açılmıştır.Fesih Talebi Formu dökümanlar alanına eklenmiştir.`,
      priorityId: 3,
      urgencyId: 1,
      customerId: values.customerId,

      detail: {
        categoryId: "fb2f0e15-cad1-487c-8e01-08dbf71af446",
        actionFieldId: 1,
      },
      documents: [{ ...values }],
    };

    if (!isExists(values.file)) {
      setSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Değerli Müşterimiz,",
        text: translate("resources.workOrders.valid.file"),
      });
    } else {
      const val = {
        document: { ...values },
        workOrder: workOrderValues,
      };
      saveHandler(val, { setSubmitting }, createMethod);
    }
  }

  return (
    <>
      <div
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Formik
          initialValues={{
            documentDetail: {},
            customerId: customerId,
            fileCategoryId: 1,
            description: "",
            file: {
              base64: "",
              fileName: "",
              contentType: "",
            },
          }}
          onSubmit={submitHandler}
        >
          {(props) => (
            <Form>
              <div
                style={{
                  padding: "38px",
                  marginBottom: "30px",
                  marginTop: "-17px",
                  borderBottom: "1px solid #e0e0e0",
                  borderRadius: "15px 15px 0px 0px",
                }}
              >
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="warning"
                      startIcon={<PictureAsPdfIcon />}
                      rel="noopener noreferrer"
                      href="/documents/isnet-abonelik-fesih-dilekcesi.pdf"
                      target="_blank"
                      sx={{ textTransform: "none", marginRight: "15px" }}
                    >
                      Fesih Dilekçesi PDF
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="info"
                      startIcon={<ArticleIcon />}
                      rel="noopener noreferrer"
                      href="/documents/isnet-abonelik-fesih-dilekcesi.docx"
                      target="_blank"
                      sx={{ textTransform: "none" }}
                    >
                      Fesih Dilekçesi WORD
                    </Button>
                  </Grid>
                </Grid>
              </div>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <ModalDocument
                    open={openDoc}
                    setOpen={setOpenDoc}
                    setDocument={setSendToDocument}
                  />
                </Grid>
              </Grid>

              <FormFooter>
                <Grid container justifyContent="center" spacing={3}>
                  {props.isSubmitting ? (
                    <IsSubmittingButton />
                  ) : (
                    <>
                      <Grid item>
                        <CreateButton
                          disabled={
                            props.isSubmitting || Number(user.isReadOnly) === 1
                          }
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </FormFooter>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default Cancelation;
